/**
 * @description What mode this action should be executed in
 */
export var ExecutionMode;
(function (ExecutionMode) {
    /**
     * Opens the entity (content, app, person) outside of the hub
     */
    ExecutionMode["OpenExternal"] = "open-external";
    /**
     * @description Performs the action on an entity in context (either a dialog, sidecar, other)while keeping the user inside the hub
     *
     * @todo Decide how hubs extend this as well as communicate the available contexts available to developers
     */
    ExecutionMode["InContextUx"] = "open-in-context";
    /**
     * @description Open the app either within the current hub or in a new target
     */
    ExecutionMode["DeepLinkToApp"] = "deep-link-to-app";
    /**
     * @description Invokes an API or submits a payload from an action on an entity to a remote endpoint.
     * Think bots, services, etc.
     */
    ExecutionMode["Submit"] = "submit-action";
})(ExecutionMode || (ExecutionMode = {}));
/**
 * @description Entity that this action can be run in
 *
 * Reference - Some uses of 'context' from prior art:
 *   - https://docs.microsoft.com/en-us/microsoftteams/platform/messaging-extensions/how-to/action-commands/define-action-command#create-an-action-command-manually
 *   - https://docs.microsoft.com/en-us/microsoftteams/platform/resources/schema/manifest-schema#composeextensionscommands
 */
export var ActionEntityType;
(function (ActionEntityType) {
    ActionEntityType["App"] = "app";
    ActionEntityType["Content"] = "content";
    ActionEntityType["Mail"] = "mail";
    ActionEntityType["Message"] = "message";
})(ActionEntityType || (ActionEntityType = {}));
/**
 * What 'intents' do you anticipate your users accomplishing with these actions inside the hub they're in?
 *
 * Right now, the only one we currently split out in office.com for content is create. Whether or not your app is opening or editing with
 * an action is up to action author. Could see intents being used for 'suggested' actions for apps not yet installed in the future.
 *
 * @todo: This could also go the other way. Similar to how mobile apps work on Android (I am an app, I can handle these certain intents, etc)
 */
export var ActionIntent;
(function (ActionIntent) {
    ActionIntent["ContentEdit"] = "content-edit";
    ActionIntent["ContentCreate"] = "content-create";
    ActionIntent["ContentView"] = "content-view";
})(ActionIntent || (ActionIntent = {}));
export var NextActionMode;
(function (NextActionMode) {
    NextActionMode["Background"] = "Background";
    NextActionMode["Notification"] = "Notification";
})(NextActionMode || (NextActionMode = {}));
//# sourceMappingURL=actionDefinition.js.map